import env from '../../../environment';
import tgss from '../../../assets/onboarding/tgss.png';
import aeat from '../../../assets/onboarding/aeat.png';
import upIcon from '../../../assets/icons/upIcon.png';
import tgssDisabled from '../../../assets/onboarding/tgssDisabled.png';
import aeatDisabled from '../../../assets/onboarding/aeatDisabled.png';
import tesoro from '../../../assets/onboarding/tesoro.png';
import agencia from '../../../assets/onboarding/agencia.png';
import plus from '../../../assets/icons/plusIcon.png';
import { DocumentBoxesComponent } from 'mortgage-documents';
import tagSabadell from '../../../components/tagSabadell';
import eventSabadell from '../../../components/eventSabadell';

const DocumentationNew = ({ userMortgageId, stage, setDocsNumber }) => {
	return (
		<DocumentBoxesComponent
			userMortgageId={userMortgageId}
			platform="sabadell"
			stage={stage}
			env={env}
			traceSadabdell={tagSabadell}
			eventSabadell={eventSabadell}
			images={{
				tgss,
				aeat,
				upIcon,
				tgssDisabled,
				aeatDisabled,
				tesoro,
				agencia,
				plus
			}}
			setDocsNumber={setDocsNumber}
		/>
	);
};

export default DocumentationNew;
